import { localizedMedia } from '../i18n/resources';
import { t } from '../i18n';
import phoneOriginal from "../img/phone.png";
import mailOriginal from "../img/mail.png";
import fbOriginal from "../img/fb.png";
import isOriginal from "../img/is.png";
import ytOriginal from "../img/yt.png";
import mlOriginal from "../img/ml.png";

const phone = localizedMedia(phoneOriginal, "phone.png");
const mail = localizedMedia(mailOriginal, "mail.png");
const fb = localizedMedia(fbOriginal, "fb.png");
const is = localizedMedia(isOriginal, "is.png");
const yt = localizedMedia(ytOriginal, "yt.png");
const ml = localizedMedia(mlOriginal, "ml.png");
const Footer = () => {
    return(
        <>
        <div className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-lg-2"></div>
                        <div className="col-sm-12 col-lg-4">
                            <br />
                            <h4>{t("Soft99 Garage Kupiec Poznański")}</h4>
                            <p>{t("plac Wiosny Ludów 2")}</p>
                            <p>{t("61-831, Poznań")}</p>
                            <p>{t("(poziom -1 parkingu Kupca Poznańskiego)")}</p>
                            <p><br /></p>
                            <p>+48 516 712 233</p>
                            <p>{t("info@myjniasoft99.pl")}</p>
                            <p><br /></p>
                            <h4>{t("Godziny otwarcia")}</h4>
                            <table>
                                <thead></thead>
                                <tbody>
                                    <tr>
                                        <td>{t("Pon - Pt")}</td>
                                        <td>8:00 - 21:00</td>
                                    </tr>
                                    <tr>
                                        <td>{t("Sob")}</td>
                                        <td>10:00 - 20:00</td>
                                    </tr>
                                    <tr>
                                        <td>{t("Ndz")}</td>
                                        <td>11:00 - 19:00</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> 
                        <div className="col-sm-12 col-lg-4">
                            <br />
                            <h4>{t("Soft99 Garage Wierzbięcice")}</h4>
                            <p>{t("Wierzbięcice 2A")}</p>
                            <p>{t("61-568, Poznań")}</p>
                            <p><br /><br /></p>
                            <p>+48 607 285 285</p>
                            <p>{t("kontakt@soft99garage.pl")}</p>
                            <p><br /></p>
                            <h4>{t("Godziny otwarcia")}</h4>
                            <table>
                                <thead></thead>
                                <tbody>
                                    <tr>
                                        <td>{t("Pon - Pt")}</td>
                                        <td>10:00 - 18:00</td>
                                    </tr>
                                    <tr>
                                        <td>{t("Sob")}</td>
                                        <td>9:00 - 15:00</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>                   

                        <div className="col-sm-12 col-lg-2"></div>
                        <div className="col-sm-12 col-lg-12">
                            <div className="socialFooter">
                                <a href="https://www.facebook.com/Soft99Garage" target="_blank" className="socialFooterItem"><img className="social-footer-icon" src={fb} alt=""></img></a>
                                <a href="https://www.instagram.com/soft99_garage_poznan/" target="_blank" className="socialFooterItem"><img className="social-footer-icon" src={is} alt=""></img></a>
                                <a href="https://www.youtube.com/c/Soft99Europe" target="_blank" className="socialFooterItem"><img className="social-footer-icon" src={yt} alt=""></img></a>
                            </div>
                        </div>   
                    </div>
                </div>
            </div>
           <script src='https://cdn1.pdmntn.com/a/BkFwFnZgh.js'></script> 
           </>
    )
}

export default Footer;
